import {
  ApiError,
  OpenAPI,
  getApiPublicThreadComments,
  getApiPublicThreadInfo,
  postApiPublicCommentReaction,
  postPublicPostComment,
  postPublicPostReply,
  postPublicApiPublicCommentPostCommentComplaint,
} from '@Comments/openapi/client/index';
import { SortOrder } from '@Comments/models/SortOrder';
import { useAppContext } from '@Comments/context/AppContext';
import { useCallback } from 'react';

export const useLoader = () => {
  const { env, user } = useAppContext();
  OpenAPI.BASE = env.base;

  const getUserToken = useCallback((): string => {
    if (env.loginProvider === 'srg-login') {
      return user.token;
    }

    return `Janrain ${user.token}`;
  }, [env.loginProvider, user.token]);

  return {
    loadCommentsByThread: useCallback(
      (limit: number, nextToken: number, sort?: SortOrder) => {
        OpenAPI.TOKEN = undefined;
        return getApiPublicThreadComments({
          urn: env.threadUrn,
          bu: env.bu,
          limit: limit,
          nextToken: nextToken,
          sort: sort,
        });
      },
      [env.bu, env.threadUrn],
    ),
    getThreadInfo: useCallback(() => {
      OpenAPI.TOKEN = undefined;
      return getApiPublicThreadInfo({
        bu: env.bu,
        urn: env.threadUrn,
      });
    }, [env.bu, env.threadUrn]),
    likeComment: useCallback(
      (urn: string) => {
        OpenAPI.TOKEN = getUserToken();
        return postApiPublicCommentReaction({
          urn,
          bu: env.bu,
          requestBody: {
            expression: 'like',
          },
        });
      },
      [env.bu, getUserToken],
    ),
    saveComment: useCallback(
      (text: string) => {
        OpenAPI.TOKEN = getUserToken();
        return postPublicPostComment({
          bu: env.bu,
          requestBody: {
            text: text,
            thread: env.threadUrn,
          },
        });
      },
      [env.bu, env.threadUrn, getUserToken],
    ),
    saveReplyToComment: useCallback(
      (text: string, parentUrn: string) => {
        OpenAPI.TOKEN = getUserToken();
        return postPublicPostReply({
          bu: env.bu,
          urn: parentUrn,
          requestBody: {
            text: text,
          },
        });
      },
      [env.bu, getUserToken],
    ),
    saveComplaint: useCallback(
      (urn: string) => {
        OpenAPI.TOKEN = getUserToken();
        return postPublicApiPublicCommentPostCommentComplaint({
          bu: env.bu,
          urn: urn,
        });
      },
      [env.bu, getUserToken],
    ),
  };
};

export const getServerUiMessage = (error: ApiError): string => {
  let uiMessage = '';
  const status = error.status ?? null;
  if (status === 401 || status === 403) {
    uiMessage = 'UNAUTHORIZED';
  } else if (status >= 400 && status < 500 && (error as any).body.message) {
    uiMessage = (error as any).body.message;
  }
  return uiMessage;
};
